import React from "react";
import "./MealsList.css";
import MealsData from "../Meals/MealsData";
import { useNavigate } from "react-router-dom";

export default function MealsList(props) {
  const navigate = useNavigate();

  const openMealCalorieHandler = (meal) => {
    navigate(`/mealCalorieSelector/${meal.id}`, {
      state: { date: props.shamsiDate, mealLabel: meal.label },
    });
  };

  return (
    <ul className="mealsListContainer">
      {MealsData.map((meal) => (
        <li
          key={meal.id}
          className="mealItem centeredFlex responsiveWidth"
          onClick={() => openMealCalorieHandler(meal)}
        >
          <div className="mealItemRight centeredFlex">
            <img
              className="clipboardIcon"
              src="/images/clipboard.svg"
              alt="clipboard icon"
            />

            <p className="mealItemCalories">
              {props.mealsData && props.mealsData[meal.label]
                ? Number.isInteger(props.mealsData[meal.label])
                  ? props.mealsData[meal.label].toFixed(1)
                  : props.mealsData[meal.label].toFixed(2)
                : 0.0}{" "}
              cal
            </p>
          </div>
          <div className="mealItemLeft centeredFlex">
            <span className="mealItemName">{meal.name}</span>
            <img src={meal.img} alt="meal icon" className="mealItemImg" />
          </div>
        </li>
      ))}
    </ul>
  );
}
